import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import ky from 'ky';

import { authLogin } from '../redux/workBackendSlice';
import useInitilaizeDb from '../hooks/useInitilaizeDb';
import useWorkBackend from '../hooks/useWorkBackend';
import useSetUserCondition from '../hooks/useSetUserCondition';

import { setTokensToCookie, getCookie } from '../general';
import Digimagi from './Digimagi';

export const apiURL = process.env.REACT_APP_API_URL;

const DigimagiProvider: React.FC = () => {
  const dispatch = useDispatch();
  const authUser = useWorkBackend().authUser;
  useInitilaizeDb();
  useSetUserCondition();

  const refreshToken = async () => {
    try {
      console.log('refresh token start')
      const uId = getCookie('user_id');
      const refresh_token = getCookie('refresh_token');
      const sendData = {
        user_id: uId,
        refresh_token: refresh_token
      }
      const res = await ky.post(`${apiURL}refresh_token`, { json: sendData }).json() as any;
      const data = res.data;
      setTokensToCookie(data);
      console.log('refresh token end')
      return true;
    } catch (err) {
      console.log(err)
      return false;
    }
  }

  useEffect(() => {
    const checkToken = async () => {
      try {
        const uId = getCookie('user_id');
        const token = getCookie('token');
        const data = {
          user_id: uId,
          token: token
        }
        const check = await ky.post(apiURL + 'token_check', { json: data }).json() as any;
        const checkData = check.data;
  
        if (typeof checkData[0].count === undefined || checkData[0].count < 1) {
          return await refreshToken();
        } else {
          return true;
        }
      } catch (err) {
        console.log(err)
        return await refreshToken();
      }
    }
    const loginCheck = async () => {
      if (await checkToken()) {
        console.log('ログイン成功');
        dispatch(authLogin(true));
      } else {
        console.log('ログイン失敗');
        dispatch(authLogin(false));
      }
    }
    loginCheck();
  }, [])

  if (authUser === null) return <></>;
  else return <Digimagi />;
}

export default DigimagiProvider;
